import React, { Component } from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Header,
  Form,
  Grid,
  Menu,
  Segment,
  Message,
} from "semantic-ui-react";
import * as ROUTES from "../../routes";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import authenticate from "../../authenticate";
import AuthManagement from "feathers-authentication-management/lib/client";

class ChangePasswordView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      oldPassword: "",
      newPassword: "",
      newPasswordRepeat: "",
      validationError: null,
      submitError: null,
      prefilled: false,
      loading: false,
    };

    this.FeathersService = this.props.services.feathers;
    this.AuthManagement = AuthManagement(this.FeathersService);
    this.AuthenticationService = authenticate(
      this.props.services.feathers,
      this.props.dispatch
    );
  }

  static mapDispatchToProps(dispatch) {
    return {
      dispatch,
      navigate: (path) => dispatch(push(path)),
    };
  }

  static mapStateToProps(state) {
    return {
      authentication: state.authentication.toJS(),
    };
  }

  componentDidMount() {
    this.verificationLogic(this.props);
    if (!!this.props.match.params.oldPassword) {
      this.setState({
        oldPassword: this.props.match.params.oldPassword,
        prefilled: true,
      });
    }
  }

  verificationLogic = (props = this.props) => {
    const roles =
      props.authentication &&
      props.authentication.user &&
      props.authentication.user.roles
        ? props.authentication.user.roles
        : [];

    if (
      props.authentication &&
      props.authentication.user &&
      props.authentication.user.id
    ) {
      if (!props.authentication.user.needsReset) {
        if (roles.indexOf("sysadmin") === -1) {
          props.navigate(ROUTES.DASHBOARD);
        } else {
          props.navigate(ROUTES.ADMIN);
        }
      }
    } else {
      props.navigate(ROUTES.SIGNIN);
    }
  };

  componentDidUpdate(prevProps) {
    this.verificationLogic(this.props);
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  onSubmit = () => {
    const { oldPassword, newPassword, newPasswordRepeat } = this.state;

    if (newPasswordRepeat !== newPassword) {
      this.setState({ validationError: "Las contraseñas nuevas no coinciden.", submitError: null });
      return;
    }

    if (!newPassword || newPassword.length < 8) {
      this.setState({ validationError: "La nueva contraseña debe tener al menos 8 caracteres.", submitError: null });
      return;
    }

    this.setState({
      validationError: null,
      submitError: null,
      loading: true,
    });

    this.AuthManagement.passwordChange(oldPassword, newPassword, {
      email: this.props.authentication.user.email,
    })
      .then((response) => {
        this.setState({
          loading: false,
        });
        window.location.reload();
      })
      .catch((error) => {
        this.setState({
          loading: false,
          validationError: null,
          submitError: (error && error.message) || "No se pudo cambiar la contraseña.",
        });
      });
  };

  render() {
    const { t, authentication } = this.props;
    const { error } = authentication;
    const { validationError, submitError } = this.state;

    return (
      <Container>
        <Menu
          inverted
          style={{ backgroundColor: "#136444", borderRadius: 0, margin: 0 }}
        >
          <Menu.Item name="inicio" active={true} />
          <Menu.Item name="nosotros" active={false} />
        </Menu>

        <Segment vertical secondary style={{ padding: 4 }}>
          <Breadcrumb>
            <Breadcrumb.Section as={Link} link to={"/"}>
              Inicio
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section active>Ingreso</Breadcrumb.Section>
          </Breadcrumb>
        </Segment>

        <Segment vertical>
          <Header as="h3">
            <Header.Content>
              INGRESAR
              <Header.Subheader>Acceso al sistema</Header.Subheader>
            </Header.Content>
          </Header>
        </Segment>

        <Segment vertical>
          <Grid columns={3} centered>
            <Grid.Column>
              <Segment clearing color="blue">
                <Form
                  onSubmit={this.onSubmit}
                  error={!!error || !!validationError || !!submitError}
                  loading={!!this.state.loading}
                >
                  <Message
                    error
                    hidden={!validationError}
                    header="Error de validacion"
                    content={validationError || ""}
                  />
                  <Message
                    error
                    hidden={!submitError}
                    header="No se pudo actualizar la contraseña"
                    content={submitError || ""}
                  />
                  <Message
                    error
                    header={!!error && error.name}
                    content={!!error && error.message}
                  />
                  <Form.Input
                    label="Usuario"
                    name="username"
                    value={
                      !!this.props.authentication.user &&
                      !!this.props.authentication.user.email
                        ? this.props.authentication.user.email
                        : ""
                    }
                    disabled
                  />
                  <Form.Input
                    label="Clave anterior"
                    disabled={this.state.prefilled}
                    name="oldPassword"
                    type="password"
                    onChange={this.handleChange}
                  />
                  <Form.Input
                    label="Nueva contraseña"
                    name="newPassword"
                    type="password"
                    onChange={this.handleChange}
                  />
                  <Form.Input
                    label="Nueva contraseña, de nuevo"
                    name="newPasswordRepeat"
                    type="password"
                    onChange={this.handleChange}
                  />
                  <Button
                    content="Enviar"
                    icon="send"
                    type="submit"
                    floated="right"
                    primary
                  />
                </Form>
              </Segment>
            </Grid.Column>
          </Grid>
        </Segment>
      </Container>
    );
  }
}

const i18nEnhancement = translate("translations")(ChangePasswordView);
export default connect(
  ChangePasswordView.mapStateToProps,
  ChangePasswordView.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/ChangePasswordView.jsx